import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';

import { ScorecastOptionGroupComponent } from '../scorecast-option-group.component';
import { MultiColumnDropdownOption } from '../scorecast-option-group.model';

@Component({
    selector: 'ms-wincast-option-group',
    templateUrl: './wincast-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ScorecastOptionGroupComponent],
})
export class WincastOptionGroupComponent {
    @HostBinding() class = 'ms-wincast-option-group';

    @Input() event: EventModel;
    @Input() optionGroup: EventOptionGroup;
    @Input() markets: MultiColumnDropdownOption[] | undefined;
    @Input() options: MultiColumnDropdownOption[] | undefined;
    @Input() eventHelpText: string | undefined;
    @Input() showMarketHelp = false;
    @Input() tracking: string;
    @Input() trackingModuleType = '';
    @Input() sourceOfPick = SourceOfPick.Other;
    @Input() betDetails = '';

    marketTitle: string | undefined;
    optionTitle: string | undefined;

    constructor() {
        const sitecore = inject(Sitecore);

        this.marketTitle = sitecore.event.GoalScorerTitle;
        this.optionTitle = sitecore.event.ScoreTitle;
    }
}
